"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shallowClone = shallowClone;
exports.objectHasValue = objectHasValue;
exports.isEmptyObject = isEmptyObject;
exports.mapValues = mapValues;
function shallowClone(object) {
    return { ...object };
}
function objectHasValue(object, value) {
    return Object.keys(object).some((key) => object[key] === value);
}
function isEmptyObject(object) {
    return Object.keys(object).length === 0;
}
function mapValues(object, fn) {
    const newObject = {};
    for (const key of Object.keys(object)) {
        newObject[key] = fn(object[key]);
    }
    return newObject;
}
//# sourceMappingURL=objectUtils.js.map